export default "__VITE_ASSET__CJ9dVTWb__"